var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myMenu",attrs:{"id":"myMenu"}},[_c('ul',_vm._l((_vm.val),function(item){return _c('li',{key:item,class:_vm.activeClass == item ? 'active':'',on:{"mouseover":function($event){return _vm.mouseover($event,item)}}},[_c('router-link',{attrs:{"to":""}},[_vm._t(item)],2)],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }